import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../providers/api.service";
@Component({
  selector: 'app-banners-image',
  templateUrl: './banners-image.component.html',
  styleUrls: ['./banners-image.component.css']
})
export class BannersImageComponent implements OnInit {

  PospBannersData: any = [];


  constructor(public api: ApiService) { }

  ngOnInit() {
    this.GetDashBoardAgentWise('7');
  }





  GetDashBoardAgentWise(Id: any) {
    this.api
      .HttpGetType(
        "V2/Reportsnew/GetDashBoardAgentWise?Id=" +
        Id +
        "&User_Id=" +
        this.api.GetUserData("Id") +
        "&User_Type=" +
        this.api.GetUserType() +
        "&User_Code=" +
        this.api.GetUserData("Code") +
        "&Type=Claim" + "&bannerType='All'"
      )
      .then(
        (result: any) => {
          // console.log(result);
          //this.api.HideLoading();
          if (result["Status"] == true) {
           
            if (result["Id"] == 7) { // Posp Banners Data 
              this.PospBannersData = result["Data"];
            }
            // console.log(this.PospBannersData);
          }
        },
        (err) => {
          // Error log
          //// console.log(err);
          this.api.HideLoading();
          this.api.Toast(
            "Warning",
            "Network Error : " + err.name + "(" + err.statusText + ")"
          );
          //this.api.ErrorMsg('Network Error :- ' + err.message);
        }
      );
  }



  downloadFile(url: string) {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.download = url.split('/').pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

}
